import { Diagram } from '../../diagram'
import type { DataCheckActionNode } from '../../node/types'
import DolfinRecord from '../../record'
import { DolfinRpc } from '../../rpc'
import { NodeError, NodeWarning } from '../../types'
import { Action } from '../index'

export class DataCheckAction extends Action<DataCheckActionNode> {
  constructor(
    node: DataCheckActionNode,
    record: DolfinRecord,
    organizationId: number,
    rpcClient: DolfinRpc
  ) {
    super(node, record, organizationId, rpcClient)
  }
  async run() {
    const { label, description } = this.parseVariables()

    return [
      {
        name: 'label',
        value: label
      },
      {
        name: 'description',
        value: description
      }
    ]
  }

  parseVariables(): Record<string, any> {
    return {
      label: this.node.data.formData.label ?? '',
      description: this.node.data.formData.description ?? ''
    }
  }

  static validate(
    node: DataCheckActionNode,
    diagram: Diagram
  ): {
    node: DataCheckActionNode
    errors: NodeError[]
    warnings: NodeWarning[]
  } {
    const superValidation = super.validate(node, diagram)

    if (!node.data.formData.label || node.data.formData.label.trim() === '') {
      superValidation.errors.push({
        message: 'Label is required',
        node
      })
    }

    if (!node.data.formData.description || node.data.formData.description.trim() === '') {
      superValidation.errors.push({
        message: 'Description is required',
        node
      })
    }

    return {
      node,
      errors: [...superValidation.errors],
      warnings: [...superValidation.warnings]
    }
  }
}
